/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="66.53" height="95.58" viewBox="0 0 66.53 95.58" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <polygon points="47.77 38.23 47.77 44.23 18.76 44.23 18.76 38.23 47.77 38.23" fill="#ffb81c"/><g>
          <path d="M88.37,31.06a1.25,1.25,0,0,1,1.25,1.25,12.36,12.36,0,1,1-24.71,0,1.25,1.25,0,1,1,2.5,0,9.86,9.86,0,1,0,19.71,0A1.25,1.25,0,0,1,88.37,31.06Z" transform="translate(-44 -30)" fill="#0e497b"/>
          <path d="M67,125.58h-.12l-21.79-2.26A1.25,1.25,0,0,1,44,121.79l0-.12L61.21,71.26,53.14,40.18a1.27,1.27,0,0,1,.39-1.26l.1-.07L65.9,30.23a1.21,1.21,0,0,1,.57-.22H87.9a1.2,1.2,0,0,1,.59.15l.13.08,12.27,8.62a1.25,1.25,0,0,1,.52,1.21l0,.12L93.32,71.26l17.14,50.41a1.25,1.25,0,0,1-.93,1.63l-.12,0-21.79,2.26H67Zm20.4-2.5L107.59,121,90.83,71.71a1.37,1.37,0,0,1-.06-.57l0-.14,7.94-30.61L87.51,32.5H67L55.78,40.39,63.72,71a1.22,1.22,0,0,1,0,.57l0,.14L46.94,121l20.16,2.09Z" transform="translate(-44 -30)" fill="#0e497b"/>
        </g>
      </svg>

    );
  }
}

Icon.displayName = 'DressIcon';

export default Icon;
